// extracted by css-extract-rspack-plugin
export default {"root":"MNMU_","tabsBar":"xXLkA","content":"DiDfB"};